import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { ApiService } from '../../lib/api.service';
import { BookableEvent, bookableEvents } from '../../lib/events';
import { Festival } from '@shared';
import { DatePipe, NgForOf } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingComponent } from '../../loading/loading.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-event-selection',
  imports: [NgForOf, LoadingComponent, RouterLink, DatePipe],
  templateUrl: './event-selection.component.html',
  styleUrl: './event-selection.component.css',
})
export class EventSelectionComponent {
  public readonly apiService = inject(ApiService);
  public festivals = computed<Festival[]>(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return this.festivalsInternal().filter((festival) => new Date(festival.valid_to_date || '').getTime() > today.getTime())
  });
  public festivalsInternal = toSignal(this.apiService.fetchFestivals(), {
    initialValue: [],
  });
  protected readonly bookableEvents = bookableEvents;

  public slugById(id: number | undefined) {
    return bookableEvents.find((bookableEvent) => bookableEvent.apiId === id)
      ?.slug;
  }
}
